import { LoadingButton } from '@mui/lab';
import {
  Alert,
  AlertColor,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
} from '@mui/material';
import React, { useState } from 'react';
import { useEndExercise } from '../../api';

export interface EndExerciseDialogProps {
  exerciseId?: string;
  onCompleted?: () => void;
  onDeleted?: () => void;
  onError?: () => void;
  onClose: () => void;
  open: boolean;
}

const EndExerciseDialog = ({ exerciseId, open, onError, onDeleted, onCompleted, onClose }: EndExerciseDialogProps) => {
  const [toastDialog, setToastDialog] = useState<{ open: boolean; message?: string; severity?: AlertColor }>({
    open: false,
    severity: 'error',
  });

  const { isLoading, endExercise } = useEndExercise(
    (data: { message: string }) => {
      setToastDialog({ open: true, message: `${data?.message}.`, severity: 'success' });

      data?.message === 'The exercise was successfully deleted'
        ? onDeleted && onDeleted()
        : onCompleted && onCompleted();
    },

    () => {
      setToastDialog({ open: true, message: 'Something went wrong. Please try again.', severity: 'error' });

      onError && onError();
    },
  );

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
        <DialogTitle>Are you sure you want to end exercise?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Exercise will be deleted when there are no simulation runs.
            <br />
            Exercise will be moved from &apos;Active&apos; to &apos;Completed&apos; when there are simulation runs
            available.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton onClick={() => endExercise(exerciseId)} loading={isLoading} variant="contained">
            Confirm
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={toastDialog.open}
        onClose={() => setToastDialog({ ...toastDialog, open: false })}
      >
        <Alert onClose={() => setToastDialog({ ...toastDialog, open: false })} severity={toastDialog.severity}>
          {toastDialog.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EndExerciseDialog;
